import { render } from "./ArchivoPlaUploadModal.vue?vue&type=template&id=c0845c04&scoped=true"
import script from "./ArchivoPlaUploadModal.vue?vue&type=script&lang=js"
export * from "./ArchivoPlaUploadModal.vue?vue&type=script&lang=js"

import "./ArchivoPlaUploadModal.vue?vue&type=style&index=0&id=c0845c04&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0845c04"]])

export default __exports__